import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MapMarker, MapInfoWindow } from '@angular/google-maps';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { widgetEditMode, IReturnChangesWidgetEditForm, deepCopy, openMapDirection, makeid, checkIfFieldDisabled } from 'na-lib';
import { SettingsService } from 'src/app/service/settings.service';
import { supportUrlStructure } from 'src/app/supportUrls';
import { AnnotatedmapAnnotationDialogComponent } from '../annotatedmap-annotation-dialog/annotatedmap-annotation-dialog.component';
import { AnnotatedmapAnnotationDynamicDialogComponent } from '../annotatedmap-annotation-dynamic-dialog/annotatedmap-annotation-dynamic-dialog.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-annotatedmap-edit-form',
    templateUrl: './annotatedmap-edit-form.component.html',
    styleUrl: './annotatedmap-edit-form.component.css',
    standalone: false
})
export class AnnotatedmapEditFormComponent {
  @Input() data:widgetEditMode;
  @Output() returnChanges = new EventEmitter<IReturnChangesWidgetEditForm>();
  
  annotatedMapEditForm!:FormGroup
  annotatedMapEditData:any
  widgetNumber:any
  defaultLanguage:string
  oldData:any
  passId:any
  translationModeOriginal = false
  translationMode = false
  translationForm!:FormGroup
  translateFields = []

  allAnnotationsMap:any = []
  addList:any
  changeAnnotations=false
  newAnnotations!:FormGroup
  allAnnotationsDynamicMap:any = []

  center: google.maps.LatLngLiteral = {lat: 44, lng: 12};
  zoom = 4;
  markerOptions: google.maps.MarkerOptions = {draggable: false};
  markerPositions: google.maps.LatLngLiteral[] = [];
  actualPolygonOptions:any={}
  pairsPath:any ={}
  polylineOptions = {
    path: [],
    strokeColor: '#adff2f',
    strokeOpacity: 1.0,
    strokeWeight: 3,
  };
  a: google.maps.Polyline

  polygonOptions = {
    paths: [],
    strokeColor: "#FF0000",
    strokeOpacity: 1,
    strokeWeight: 3,
    fillColor: "#ff0000",
    fillOpacity: 0.3,
    clickable: true
    // draggable: true,
    // geodesic: true,
  }
  oldTranslations:any
  passLanguagesList:any

  linkURL:any = {}
  map:google.maps.Map
  mapId:any
  prev_infowindow:any
  userHasBetaWidgetRole = false
  valuesTranslated = {}


  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
    private settingsService: SettingsService,
    private translate : TranslateService
  ){ }

  ngOnInit(): void {
    if(this.settingsService.checkIfBetaRoleAccess())
    this.userHasBetaWidgetRole = true

    this.defaultLanguage = this.data.defaultLanguage
    this.annotatedMapEditData = deepCopy(this.data.values)
    this.oldData = deepCopy(this.data.values)
    this.passId = this.data.passId
    this.widgetNumber = this.data.widget
    this.translationMode = this.data.translateMode

    if(this.data.translateMode){
      let translateData = deepCopy(this.data.translateData)
      const {fields, originalLanguageData, defaultLanguageWidgetData, valuesTranslated, selectedLanguage, values} = translateData
      this.valuesTranslated = deepCopy(valuesTranslated)
      this.translateFields = fields

      if(translateData.originalLanguageData){
        this.translationModeOriginal = true
        this.initTranslateEditData( defaultLanguageWidgetData, valuesTranslated, originalLanguageData, [],selectedLanguage)
      }else{
        this.translationModeOriginal = false
        this.initTranslateEditData(values,valuesTranslated, originalLanguageData, fields, selectedLanguage)
      }
    }
    else
    this.initWidgetEdit()
  }


  initWidgetEdit(){
    const {id, filter, type, style, layout, widgetStyle, title, subtitle, annotationGroup, annotations,name} = this.annotatedMapEditData

    annotations.forEach( annotation => {
      this.allAnnotationsMap.push(annotation)
      if(annotation.dynamic){
        if(annotation?.properties?.linkURL)
          this.linkURL[annotation.id] = supportUrlStructure(annotation.properties.linkURL, this.passId, this.settingsService.contextId$)
      }else{
        if(annotation.linkURL)
          this.linkURL[annotation.id] = supportUrlStructure(annotation.linkURL, this.passId, this.settingsService.contextId$)
      }
    })

    this.annotatedMapEditForm = this.fb.group({
      id:[{value: id ? id : undefined, disabled:false}],
      type:[{value: type ? type : undefined, disabled:false}],
      style: [{value: style ? style : undefined, disabled: false}],
      layout:[{value:layout ? layout : undefined, disabled: false}],
      title:[{value: title ? title :undefined, disabled:false}],
      subtitle:[{value: subtitle ? subtitle : undefined, disabled: false}],
      annotationGroup:[{value: annotationGroup ? annotationGroup : undefined, disabled: false}],
      annotations:[{value: annotations ? annotations : undefined, disabled: false}],
      name:[{ value: name ? name : undefined, disabled: false}],
      filter: [{value: filter ? filter : undefined, disabled: false}],
      widgetStyle: [{value: widgetStyle ? widgetStyle : undefined, disabled: false}]
    })

    this.annotatedMapEditForm.get('annotations').valueChanges.subscribe( (value:any) => {
      this.loadNewMarkersOnMap()
    })

    this.annotatedMapEditForm.valueChanges.subscribe( value => {
      this.returnChanges.emit({
        type:"annotatedMap",
        form: this.annotatedMapEditForm,
        validForm: this.annotatedMapEditForm.valid,
        data: value,
        saveDisabled: false
      })
    })

    this.newAnnotations = this.fb.group({
      name:[],
      lat:[],
      lng:[]
    })

    this.loadMarkers()

    setTimeout(() => {
      this.loadMap(id)
    }, 500);
  }

  initTranslateEditData(data, valuesTranslated, originalLanguageData, fields, selectedLanguage){

    let {id, filter, type, style, layout, widgetStyle, title, subtitle, annotationGroup, annotations,name} = data
    if(!originalLanguageData){
      title = valuesTranslated[selectedLanguage + '.' + id + '.title']
      subtitle = valuesTranslated[selectedLanguage + '.' + id + '.subtitle']

      annotations.forEach( annotation => {
        this.allAnnotationsMap.push(annotation)

        if(annotation.dynamic){
          if(annotation.properties){
            if(annotation.properties.linkURL)
            this.linkURL[annotation.id] = supportUrlStructure(annotation.properties.linkURL, this.passId, this.settingsService.contextId$)
          
            annotation.properties.linkURL = valuesTranslated[selectedLanguage + '.' + id + '_' + annotation.id + '.properties.linkURL']
            annotation.properties.title = valuesTranslated[selectedLanguage + '.' + id + '_' + annotation.id + '.properties.title']
            annotation.properties.subtitle = valuesTranslated[selectedLanguage + '.' + id + '_' + annotation.id + '.properties.subtitle']
          }
        }else{
          if(annotation.linkURL)
          this.linkURL[annotation.id] = supportUrlStructure(annotation.linkURL, this.passId, this.settingsService.contextId$)
        
          annotation.linkURL = valuesTranslated[selectedLanguage + '.' + id + '_' + annotation.id + '.linkURL']
          annotation.title = valuesTranslated[selectedLanguage + '.' + id + '_' + annotation.id + '.title']
          annotation.subtitle = valuesTranslated[selectedLanguage + '.' + id + '_' + annotation.id + '.subtitle']
        }
          
      })
    }else{
      annotations.forEach( annotation => {
        this.allAnnotationsMap.push(annotation)

        if(annotation.dynamic){
          if(annotation?.properties?.linkURL)
            this.linkURL[annotation.id] = supportUrlStructure(annotation.properties.linkURL, this.passId, this.settingsService.contextId$)
        }else{
          if(annotation.linkURL)
            this.linkURL[annotation.id] = supportUrlStructure(annotation.linkURL, this.passId, this.settingsService.contextId$)
        }
          
      })
    }
    

    this.annotatedMapEditForm = this.fb.group({
      id:[{value: id ? id : undefined, disabled: checkIfFieldDisabled('id', fields, originalLanguageData)}],
      type:[{value: type ? type : undefined, disabled: checkIfFieldDisabled('type', fields, originalLanguageData)}],
      style: [{value: style ? style : undefined, disabled: checkIfFieldDisabled('style', fields, originalLanguageData)}],
      layout:[{value:layout ? layout : undefined, disabled: checkIfFieldDisabled('layout', fields, originalLanguageData)}],
      title:[{value: title ? title :undefined, disabled: checkIfFieldDisabled('title', fields, originalLanguageData)}],
      subtitle:[{value: subtitle ? subtitle : undefined, disabled: checkIfFieldDisabled('subtitle', fields, originalLanguageData)}],
      annotationGroup:[{value: annotationGroup ? annotationGroup : undefined, disabled: checkIfFieldDisabled('annotationGroup', fields, originalLanguageData)}],
      annotations:[{value: annotations ? annotations : undefined, disabled: checkIfFieldDisabled('annotations', fields, originalLanguageData)}],
      name:[{ value: name ? name : undefined, disabled: checkIfFieldDisabled('name', fields, originalLanguageData)}],
      filter: [{value: filter ? filter : undefined, disabled: checkIfFieldDisabled('filter', fields, originalLanguageData)}],
      widgetStyle: [{value: widgetStyle ? widgetStyle : undefined, disabled: checkIfFieldDisabled('widgetStyle', fields, originalLanguageData)}]
    })

    this.annotatedMapEditForm.valueChanges.subscribe( value => {
      this.returnChanges.emit({
        type:"annotatedMap",
        form: this.annotatedMapEditForm,
        validForm: this.annotatedMapEditForm.valid,
        translations: value,
        saveDisabled: false
      })
      this.loadNewMarkersOnMap()
    })

    this.loadMarkers()

    setTimeout(() => {
      this.loadMap(id)
    }, 500);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.allAnnotationsMap, event.previousIndex, event.currentIndex);
    this.annotatedMapEditForm.patchValue({annotations: this.allAnnotationsMap})
  }

  loadMarkers(){
    const {annotations} = this.annotatedMapEditForm.value
    annotations?.forEach((element:any, index) => {
      if(!element.dynamic){
        let { coordinate, name, linkURL, id, encodedContent, lat, lng} = element

        if(coordinate){
          const lats = element
          lats['lat'] = parseFloat(coordinate[0])
          lats['lng'] = parseFloat(coordinate[1])

          if(element.name){
            lats['title']=element.name
          }
          this.markerPositions.push(lats);
          this.center=lats
        }else{
          const lats = element
          const lat = parseFloat(element.lat)
          const lng = parseFloat(element.lng)
          lats['coordinate'] = [lat, lng]
            
          if(element.name)
            lats['title'] = element.name
          
          this.markerPositions.push(lats);
          this.center=lats
        }

        if(linkURL)
          this.linkURL[id] = supportUrlStructure(linkURL, this.passId, this.settingsService.contextId$)

        if(encodedContent)
          this.getPolygon(element, index)

      }else{
        this.markerPositions.push(element);
        this.allAnnotationsDynamicMap.push(element)
      }
    });
  }

  loadMap(i){
    try{
      const id = "map-edit-dialog-"+i
      this.map = new google.maps.Map(document.getElementById(id));
      this.mapId = id
      this.initMap(i)
    }catch(e){
      console.log(e)
    }
  }

  async initMap(i) {
    const id = 'map-edit-dialog-'+i
    this.mapId = id
    // // Request needed libraries.
    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
    let position = { lat: 46.83310649280406,lng : 2.9504472409971418 };
    let mapWidgetId = this.annotatedMapEditData.id
    let mapTypeId="roadmap" 

    this.map = new Map(document.getElementById(id), {
        zoom: 4,
        center: position,
        mapId: "dev",
        mapTypeId: mapTypeId,
        disableDefaultUI: true
    });

    this.map.addListener("click", (mapsMouseEvent) => {
      if(!this.data.translateMode)
      this.addMarker(mapsMouseEvent)
    });

    this.annotatedMapEditForm.value.annotations?.forEach((annotation:any, index)=> {
      const annotationId = annotation.id

      if(annotation.type){
        if(annotation.type=="point"){
          let pos = annotation
          if(annotation.coordinate){
            pos['lat']=annotation.coordinate[0]
            pos['lng']=annotation.coordinate[1]
          }

          if(!annotation.badge)
            pos['badge']=(index +1).toString()
        
          if(pos.name)
            pos['title']=pos.name
          
          let linkURL = supportUrlStructure(pos.linkURL, this.passId,this.settingsService.contextId$ )
          let contentString = "this is an example"
          contentString ='<div class="d-flex flex-column">'
          if(pos.title)
            contentString +='<p style="font-size: 16px;">'+ pos.title+'</p>'
          if(pos.subtitle)
            contentString +='<span>'+pos.subtitle+' </span>'
          if(pos.linkURL){
            contentString +='<a href="'+linkURL+'" target="_blank" style="color:var(--warmOrange);">'
              contentString +='<span class="material-symbols-outlined">link</span>'
            contentString +='</a>'
          }
          if(!pos.title && !pos.linkURL && !pos.subtitle)
            contentString +='<span>...</span>'

            if(pos['directions']){
              const directions = this.openMapDirection(annotation)
              const directionTranslation = this.translate.instant('pass.map.open_direction')
              contentString += '<a href="'+directions+'" style="flex-grow: 1;padding-left: 5px;text-decoration:none; "> <button mat-button class="secondary-gray-button w-100" style="border:none; display:flex; align-items:center;"><span class="material-symbols-outlined">open_in_new</span>'+directionTranslation+'</button></a>'
            }
          contentString +=' </div> '
        
          let iconImg = document.createElement('div');
          let pinColor = '#FF5E38'

          if(annotation.pinBackgroundColor)
            pinColor = annotation.pinBackgroundColor
          else if(annotation.pinColor)
            pinColor = annotation.pinColor

          let textColor = 'black'

          if(annotation.pinForegroundColor )
              textColor = annotation.pinForegroundColor

          const svg = `<svg width="36px" height="42px" viewBox="0 0 146 169" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >
              <title>${annotation.badge ?? index}</title>
              <g id="Page-1" stroke="${textColor}" stroke-width="2" fill="none" fill-rule="evenodd" >
                  <path d="M73,0 C113.316787,0 146,32.6832133 146,73 C146,105.660995 124.550767,133.312254 94.9700872,142.635991 L73,169 L51.0309086,142.636305 C21.449714,133.312875 0,105.661362 0,73 C0,32.6832133 32.6832133,0 73,0 Z" id="Combined-Shape" fill="${pinColor}"></path>
                  <text text-anchor="middle" x="50%" y="50%" font-size="70" fill="${textColor}">${pos.badge ?? index}</text>
                </g>
          </svg>`

          iconImg.innerHTML = svg

          let pinData = {glyph: pos.badge}
            pinData['background']=pinColor
            pinData['borderColor'] = annotation.pinForegroundColor
            pinData['glyphColor']= textColor

          const pin = new PinElement(pinData);
          const imgPin = new google.maps.marker.AdvancedMarkerElement({
            map:this.map,
            content: iconImg,
            position: pos,
            title: 'annotation_______',
          });
          const infowindow = new google.maps.InfoWindow({
            content: contentString,
            ariaLabel: index+'',
          });
          imgPin.addListener("click", () => {
            infowindow.open({ anchor: imgPin, map:this.map, });
          });

          this.map.setCenter(new google.maps.LatLng(pos['lat'], pos['lng']));
        }

        if(annotation.type=="polygon"){
          if(annotation.encodedContent){
            const encodedContent = annotation['encodedContent'].split(",")

            let pairs
                pairs = encodedContent.reduce(function(result, value, indexV, array) {
                if (indexV % 2 === 0){
                  const splited = array.slice(indexV, indexV + 2)
                  var lat: number = +splited[0];
                  var lng: number = +splited[1];
                  const value = { lat: lat, lng: lng }
                  result.push(value);
                }
                
                return result;
              }, []);

            this.pairsPath[annotationId] = pairs
            this.actualPolygonOptions[mapWidgetId]={}
            this.actualPolygonOptions[mapWidgetId][index] = this.polygonOptions
            this.actualPolygonOptions[mapWidgetId][index].paths = pairs

            if(annotation.fillColor)
              this.actualPolygonOptions[mapWidgetId][index].fillColor = annotation.fillColor

            if(annotation.strokeColor)
              this.actualPolygonOptions[mapWidgetId][index].strokeColor = annotation.strokeColor

            if(annotation.lineWidth)
              this.actualPolygonOptions[mapWidgetId][index].strokeWeight = annotation.lineWidth

            if(this.actualPolygonOptions[mapWidgetId][index] && this.actualPolygonOptions[mapWidgetId][index].paths && this.actualPolygonOptions[mapWidgetId][index].paths[0]){
              this.center=this.actualPolygonOptions[mapWidgetId][index].paths[0]
              this.zoom = 9
              const newcenter = new google.maps.LatLng(this.center)
              this.map.setCenter(newcenter);
              this.map.setZoom(this.zoom)
            }
            const polygon = new google.maps.Polygon(this.actualPolygonOptions[mapWidgetId][index])
            polygon.setMap(this.map);
          }
        }

        if(annotation.type=="line"){
          if(annotation.encodedContent){
            const encodedContent = annotation['encodedContent'].split(",")

            let pairs
                pairs = encodedContent.reduce(function(result, value, indexV, array) {
                if (indexV % 2 === 0){
                  const splited = array.slice(indexV, indexV + 2)
                  var lat: number = +splited[0];
                  var lng: number = +splited[1];
                  const value = { lat: lat, lng: lng }
                  result.push(value);
                }
                return result;
              }, []);

            this.pairsPath[annotationId] = pairs
            this.actualPolygonOptions[mapWidgetId]={}
            this.actualPolygonOptions[mapWidgetId][index] = this.polylineOptions
            this.actualPolygonOptions[mapWidgetId][index].path = pairs

            if(annotation.strokeColor)
              this.actualPolygonOptions[mapWidgetId][index].strokeColor = annotation.strokeColor

            if(annotation.lineWidth)
              this.actualPolygonOptions[mapWidgetId][index].strokeWeight = annotation.lineWidth
              
            if(this.actualPolygonOptions[mapWidgetId][index] && this.actualPolygonOptions[mapWidgetId][index].path && this.actualPolygonOptions[mapWidgetId][index].path[0]){
              this.center= this.actualPolygonOptions[mapWidgetId][index].path[0]
              this.zoom = 11
              const newcenter = new google.maps.LatLng(this.center)
              this.map.setCenter(newcenter);
              this.map.setZoom(this.zoom)
            }

            const line = new google.maps.Polyline(this.actualPolygonOptions[mapWidgetId][index]);
            line.setMap(this.map);
          }
        }

      }else{
        if(annotation.lat || annotation.lng || annotation.coordinate){
          let pos = annotation
        if(annotation.coordinate){
          pos['lat']=annotation.coordinate[0]
          pos['lng']=annotation.coordinate[1]
        }

        if(pos['lat'] || pos['lng']){
          if(!annotation.badge)
            pos['badge']=(index +1).toString()
        
        if(pos.name)
          pos['title']=pos.name
        
        let linkURL = supportUrlStructure(pos.linkURL, this.passId,this.settingsService.contextId$ )
        let contentString = "this is an example"
        contentString ='<div class="d-flex flex-column">'
          if(pos.title)
            contentString +='<p style="font-size: 16px;">'+ pos.title+'</p>'
          if(pos.subtitle)
            contentString +='<span>'+pos.subtitle+' </span>'
          if(pos.linkURL){
            contentString +='<a href="'+linkURL+'" target="_blank" style="color:var(--warmOrange);">'
                contentString +='<span class="material-symbols-outlined">link</span>'
            contentString +='</a>'
          }
          if(!pos.title && !pos.linkURL && !pos.subtitle)
            contentString +='<span>...</span>'
          
            if(pos['directions']){
              const directions = this.openMapDirection(annotation)
              const directionTranslation = this.translate.instant('pass.map.open_direction')
              contentString += '<a href="'+directions+'" style="flex-grow: 1;padding-left: 5px;text-decoration:none; "> <button mat-button class="secondary-gray-button w-100" style="border:none; display:flex; align-items:center;"><span class="material-symbols-outlined">open_in_new</span>'+directionTranslation+'</button></a>'
            }
            contentString +=' </div> '    
            
            let iconImg = document.createElement('div');
            let pinColor = '#FF5E38'

            if(annotation.pinBackgroundColor)
              pinColor = annotation.pinBackgroundColor
            else if(annotation.pinColor)
              pinColor = annotation.pinColor

            let textColor = 'black'

            if(annotation.pinForegroundColor )
                textColor = annotation.pinForegroundColor

            const svg = `<svg width="36px" height="42px" viewBox="0 0 146 169" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >
                <title>${annotation.badge ?? index}</title>
                <g id="Page-1" stroke="${textColor}" stroke-width="2" fill="none" fill-rule="evenodd" >
                    <path d="M73,0 C113.316787,0 146,32.6832133 146,73 C146,105.660995 124.550767,133.312254 94.9700872,142.635991 L73,169 L51.0309086,142.636305 C21.449714,133.312875 0,105.661362 0,73 C0,32.6832133 32.6832133,0 73,0 Z" id="Combined-Shape" fill="${pinColor}"></path>
                    <text text-anchor="middle" x="50%" y="50%" font-size="70" fill="${textColor}">${pos.badge ?? index}</text>
                  </g>
            </svg>`

            iconImg.innerHTML = svg
            let pinData = {glyph: pos.badge}
          
            pinData['background']=pinColor
            pinData['borderColor'] = annotation.pinForegroundColor
            pinData['glyphColor']= textColor

            const pin = new PinElement(pinData);
            const imgPin = new google.maps.marker.AdvancedMarkerElement({
              map:this.map,
              content: iconImg,
              position: pos,
              title: 'annotation_______',
            });
            const infowindow = new google.maps.InfoWindow({
              content: contentString,
              ariaLabel: index+'',
            });

            imgPin.addListener("click", () => {
              infowindow.open({
                anchor: imgPin,
                map:this.map,
              });
            });

            this.map.setCenter(new google.maps.LatLng(pos['lat'], pos['lng']));
          }
        }
      } 
    })
    
  }

  async loadNewMarkersOnMap(){
    const directionTranslation = this.translate.instant('pass.map.open_direction')
    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;

    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
    let position = { lat: 46.83310649280406,lng : 2.9504472409971418 };
    let mapWidgetId = this.annotatedMapEditData.id
    let mapTypeId="roadmap" 
    this.map = this.map.data.getMap()
    const div = this.map.getDiv().innerHTML=''

    this.map = new Map(this.map.getDiv(), {
      zoom: 4,
      center: position,
      mapId: "dev",
      mapTypeId: mapTypeId,
      disableDefaultUI: true
    });

    this.map.addListener("click", (mapsMouseEvent) => {
      this.addMarker(mapsMouseEvent)
    });
  
    const annotations = deepCopy(this.annotatedMapEditForm.value.annotations)  

    annotations?.forEach((annotation, index) => {
      // const annotation = annotations[t]
      const annotationId = annotation.id
      // const index = t

      if(annotation.type){
        if(annotation.type=="point"){
          let pos = annotation
          if(annotation.coordinate){
            pos['lat']=annotation.coordinate[0]
            pos['lng']=annotation.coordinate[1]
          }

          if(!annotation.badge)
            pos['badge']=(index +1).toString()
          
          if(pos.name)
            pos['title']=pos.name

          let linkURL = supportUrlStructure(pos.linkURL, this.passId,this.settingsService.contextId$ )
          let contentString = "this is an example"
          contentString ='<div class="d-flex flex-column">'
          if(pos.title)
            contentString +='<p style="font-size: 16px;">'+ pos.title+'</p>'
          if(pos.subtitle)
            contentString +='<span>'+pos.subtitle+' </span>'
          if(pos.linkURL){
            contentString +='<a href="'+linkURL+'" target="_blank" style="color:var(--warmOrange);">'
              contentString +='<span class="material-symbols-outlined">link</span>'
            contentString +='</a>'
          }
          if(!pos.title && !pos.linkURL && !pos.subtitle)
            contentString +='<span>...</span>'

            if(pos['directions']){
              const directions = this.openMapDirection(annotation)
              const directionTranslation = this.translate.instant('pass.map.open_direction')
              contentString += '<a href="'+directions+'" style="flex-grow: 1;padding-left: 5px;text-decoration:none; "> <button mat-button class="secondary-gray-button w-100" style="border:none; display:flex; align-items:center;"><span class="material-symbols-outlined">open_in_new</span>'+directionTranslation+'</button></a>'

            }
          contentString +=' </div> ' 
        
          let iconImg = document.createElement('div');
          let pinColor = '#FF5E38'

          if(annotation.pinBackgroundColor)
            pinColor = annotation.pinBackgroundColor
          else if(annotation.pinColor)
            pinColor = annotation.pinColor

          let textColor = 'black'

          if(annotation.pinForegroundColor )
              textColor = annotation.pinForegroundColor

          const svg = `<svg width="36px" height="42px" viewBox="0 0 146 169" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >
              <title>${annotation.badge ?? index}</title>
              <g id="Page-1" stroke="${textColor}" stroke-width="2" fill="none" fill-rule="evenodd" >
                  <path d="M73,0 C113.316787,0 146,32.6832133 146,73 C146,105.660995 124.550767,133.312254 94.9700872,142.635991 L73,169 L51.0309086,142.636305 C21.449714,133.312875 0,105.661362 0,73 C0,32.6832133 32.6832133,0 73,0 Z" id="Combined-Shape" fill="${pinColor}"></path>
                  <text text-anchor="middle" x="50%" y="50%" font-size="70" fill="${textColor}">${pos.badge ?? index}</text>
                </g>
          </svg>`

          iconImg.innerHTML = svg

          let pinData = {glyph: pos.badge}
        
            pinData['background']=pinColor
            pinData['borderColor'] = annotation.pinForegroundColor
            pinData['glyphColor']= textColor

          const pin = new PinElement(pinData);
          const imgPin = new google.maps.marker.AdvancedMarkerElement({
            map:this.map,
            content: iconImg,
            position: pos,
            title: 'annotation_______',
          });
          const infowindow = new google.maps.InfoWindow({
            content: contentString,
            ariaLabel: index+'',
          });

          imgPin.addListener("click", () => {
            infowindow.open({
              anchor: imgPin,
              map:this.map,
            });
          });

          this.map.setCenter(new google.maps.LatLng(pos['lat'], pos['lng']));
        }

        if(annotation.type=="polygon"){
          if(annotation.encodedContent){
            const encodedContent = annotation['encodedContent'].split(",")

            let pairs
                pairs = encodedContent.reduce(function(result, value, indexV, array) {
                if (indexV % 2 === 0){
                  const splited = array.slice(indexV, indexV + 2)
                  var lat: number = +splited[0];
                  var lng: number = +splited[1];
                  const value = { lat: lat, lng: lng }
                  result.push(value);
                }
                return result;
              }, []);

            this.pairsPath[annotationId] = pairs
            this.actualPolygonOptions[mapWidgetId]={}
            this.actualPolygonOptions[mapWidgetId][index] = this.polygonOptions
            this.actualPolygonOptions[mapWidgetId][index].paths = pairs

            if(annotation.fillColor)
              this.actualPolygonOptions[mapWidgetId][index].fillColor = annotation.fillColor

            if(annotation.strokeColor)
              this.actualPolygonOptions[mapWidgetId][index].strokeColor = annotation.strokeColor

            if(annotation.lineWidth)
              this.actualPolygonOptions[mapWidgetId][index].strokeWeight = annotation.lineWidth

            if(this.actualPolygonOptions[mapWidgetId][index] && this.actualPolygonOptions[mapWidgetId][index].paths && this.actualPolygonOptions[mapWidgetId][index].paths[0]){
              this.center=this.actualPolygonOptions[mapWidgetId][index].paths[0]
              this.zoom = 9
              const newcenter = new google.maps.LatLng(this.center)
              this.map.setCenter(newcenter);
              this.map.setZoom(this.zoom)
            }
            const polygon = new google.maps.Polygon(this.actualPolygonOptions[mapWidgetId][index])
            polygon.setMap(this.map);
          }
        }

        if(annotation.type=="line"){
          if(annotation.encodedContent){
            const encodedContent = annotation['encodedContent'].split(",")
            let pairs
                pairs = encodedContent.reduce(function(result, value, indexV, array) {
                if (indexV % 2 === 0){
                  const splited = array.slice(indexV, indexV + 2)
                  var lat: number = +splited[0];
                  var lng: number = +splited[1];
                  const value = { lat: lat, lng: lng }
                  result.push(value);
                }
                return result;
              }, []);

            this.pairsPath[annotationId] = pairs
            this.actualPolygonOptions[mapWidgetId]={}
            this.actualPolygonOptions[mapWidgetId][index] = this.polylineOptions
            this.actualPolygonOptions[mapWidgetId][index].path = pairs

            if(annotation.strokeColor)
              this.actualPolygonOptions[mapWidgetId][index].strokeColor = annotation.strokeColor

            if(annotation.lineWidth)
              this.actualPolygonOptions[mapWidgetId][index].strokeWeight = annotation.lineWidth
            
            if(this.actualPolygonOptions[mapWidgetId][index] && this.actualPolygonOptions[mapWidgetId][index].path && this.actualPolygonOptions[mapWidgetId][index].path[0]){
              this.center= this.actualPolygonOptions[mapWidgetId][index].path[0]
              this.zoom = 11
              const newcenter = new google.maps.LatLng(this.center)
              this.map.setCenter(newcenter);
              this.map.setZoom(this.zoom)
            }

            const line = new google.maps.Polyline(this.actualPolygonOptions[mapWidgetId][index]);
            line.setMap(this.map);
          }
        }

      }else{
        if(annotation.lat || annotation.lng){
          let pos = annotation
          if(annotation.coordinate){
            pos['lat']=annotation.coordinate[0]
            pos['lng']=annotation.coordinate[1]
          }

          if(!annotation.badge)
            pos['badge']=(index +1).toString()
          
          if(pos.name)
            pos['title']=pos.name

          let linkURL = supportUrlStructure(pos.linkURL, this.passId,this.settingsService.contextId$ )
          let contentString = "this is an example"
          contentString ='<div class="d-flex flex-column">'
          if(pos.title)
            contentString +='<p style="font-size: 16px;">'+ pos.title+'</p>'
          if(pos.subtitle)
            contentString +='<span>'+pos.subtitle+' </span>'
          if(pos.linkURL){
            contentString +='<a href="'+linkURL+'" target="_blank" style="color:var(--warmOrange);">'
              contentString +='<span class="material-symbols-outlined">link</span>'
            contentString +='</a>'
          }
          if(!pos.title && !pos.linkURL && !pos.subtitle)
            contentString +='<span>...</span>'

            if(pos['directions']){
            const directions = this.openMapDirection(annotation)
            const directionTranslation = this.translate.instant('pass.map.open_direction')
            contentString += '<a href="'+ directions+'" style="flex-grow: 1;padding-left: 5px;text-decoration:none; "> <button mat-button class="secondary-gray-button w-100" style="border:none; display:flex; align-items:center;"><span class="material-symbols-outlined">open_in_new</span>'+directionTranslation+'</button></a>'
            }

          contentString +=' </div> ' 
          
          let iconImg = document.createElement('div');  
          let pinColor = '#FF5E38'

          if(annotation.pinBackgroundColor)
            pinColor = annotation.pinBackgroundColor
          else if(annotation.pinColor)
            pinColor = annotation.pinColor

          let textColor = 'black'

          if(annotation.pinForegroundColor )
              textColor = annotation.pinForegroundColor

          const svg = `<svg width="36px" height="42px" viewBox="0 0 146 169" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" >
              <title>${annotation.badge ?? index}</title>
              <g id="Page-1" stroke="${textColor}" stroke-width="2" fill="none" fill-rule="evenodd" >
                  <path d="M73,0 C113.316787,0 146,32.6832133 146,73 C146,105.660995 124.550767,133.312254 94.9700872,142.635991 L73,169 L51.0309086,142.636305 C21.449714,133.312875 0,105.661362 0,73 C0,32.6832133 32.6832133,0 73,0 Z" id="Combined-Shape" fill="${pinColor}"></path>
                  <text text-anchor="middle" x="50%" y="50%" font-size="70" fill="${textColor}">${pos.badge ?? index}</text>
                </g>
          </svg>`

          iconImg.innerHTML = svg

          let pinData = {glyph: pos.badge}
            pinData['background']=pinColor
            pinData['borderColor'] = annotation.pinForegroundColor
            pinData['glyphColor']= textColor

          const pin = new PinElement(pinData);
          const imgPin = new google.maps.marker.AdvancedMarkerElement({
            map:this.map,
            content: iconImg,
            position: pos,
            title: 'annotation_______',
          });
          const infowindow = new google.maps.InfoWindow({
            content: contentString,
            ariaLabel: index+'',
          });

          imgPin.addListener("click", () => {
            infowindow.open({
              anchor: imgPin,
              map:this.map,
            });
          });

          this.map.setCenter(new google.maps.LatLng(pos['lat'], pos['lng']));
        }
      } 
    });
        
      
    
  }

  updateAllMarkersList(newone){
    this.allAnnotationsMap.push(newone)
    this.annotatedMapEditForm.patchValue({ annotations:this.allAnnotationsMap })
  }

  addMarker(event: google.maps.MapMouseEvent) {
    const badge = this.annotatedMapEditForm.value.annotations.length + 1
    const newones = event.latLng.toJSON()
    const coordinates = []
    coordinates.push(newones.lat)
    coordinates.push(newones.lng)
    this.center=newones

    newones['coordinate'] = coordinates
    newones['badge'] = badge.toString()
    newones['pinBackgroundColor'] = "#FF5E38"
    newones['pinForegroundColor'] = "#000000"
    newones['type'] = "point"
    newones['id'] = makeid(6)

    if(event.latLng != null){
        this.markerPositions.push(newones);
    }
    this.updateAllMarkersList(newones)
  }

  addAnnotation(){
    const badge = this.annotatedMapEditForm.value.annotations.length + 1
    const lat: number =+ this.newAnnotations.value.lat
    const lng: number =+ this.newAnnotations.value.lng
    const a = {
      name:this.newAnnotations.value.name,
      lat:lat, lng:lng,
      coordinate: [lat, lng],
      badge: badge,
      pinColor:"#ff0000",
      type:"point"
    }

    this.updateAllMarkersList(a)
    // this.allAnnotationsMap.push(a)
    // this.annotatedMapEditForm.patchValue({ annotations:this.allAnnotationsMap })
    this.addList=false
    this.loadMap(this.annotatedMapEditForm.value.id)
  }

  addAnnotationDialog(){
    const id = makeid(6)
    const index: number = this.markerPositions.length
    let dialogRef = this.dialog.open(AnnotatedmapAnnotationDialogComponent, {
      data:{
        id,
        type:'static',
        values:{id},
        translate: this.translationMode,
        translateOriginal: this.translationModeOriginal,
        index: (this.markerPositions.length+1).toString(),
        mapData:this.annotatedMapEditForm.value,
        // translations: this.translationForm.value.translations,
        fields: this.translateFields,
        // columns: columns,
        valuesTranslated: this.valuesTranslated,
        encodedContent: this.actualPolygonOptions[index],
        passId : this.passId,
        widgetNumber: this.widgetNumber,
        // languages: this.passLanguagesList,
      },
    });
    

    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        const {linkURL, id} = result[1]
        if(!id)
        result[1]['id'] = makeid(6)

        // this.allAnnotationsMap.push(result[1])
        this.markerPositions.push(result[1])
        this.updateAllMarkersList(result[1])
        // this.annotatedMapEditForm.patchValue({annotations:this.allAnnotationsMap})
        if(result[1].linkURL)
        this.linkURL[id] = supportUrlStructure(linkURL, this.passId, this.settingsService.contextId$)
        // this.supportLinkUrl(result[1].linkURL, result[1].id)
       
      }
    })
  }

  addDynamicAnnotation(){
    const id = makeid(6)
    let dialogRef = this.dialog.open(AnnotatedmapAnnotationDynamicDialogComponent, {
      data:{
        type:'dynamic',
        values:{
          dynamic:true,
          source:'payload',
          properties:{},
          id:id
        },
        index: (this.markerPositions.length+1).toString(),
        annotationMapData:this.annotatedMapEditForm.value,
        id,
        translate: this.translationMode,
        translateOriginal: this.translationModeOriginal,
        mapData:this.annotatedMapEditForm.value,
        // translations: this.translationForm?.value?.translations ?? {},
        fields: this.translateFields,
        // columns: columns,
        valuesTranslated: this.valuesTranslated,
        passId : this.passId,
        widgetNumber: this.widgetNumber,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        if(!result[1].id)
        result[1]['id'] = id

        this.allAnnotationsDynamicMap.push(result[1])
        // this.allAnnotationsMap.push(result[1])
        this.markerPositions.push(result[1])
        // this.annotatedMapEditForm.patchValue({annotations:this.allAnnotationsMap })
       this.updateAllMarkersList(result[1])
      }
    })
  }

  deleteAnnotation(x:any){
    this.allAnnotationsMap.splice(x,1)
    this.annotatedMapEditForm.patchValue({ annotations:this.allAnnotationsMap })
    this.markerPositions.splice(x,1)
    this.changeAnnotations=true
  }
  
  public openInfoWindow(marker: MapMarker, infoWindow: MapInfoWindow, markerPositions) {
    if(this.prev_infowindow)
      this.prev_infowindow.close()

    this.prev_infowindow = infoWindow
    infoWindow.open(marker);
  }

  openAnnotationDialog(annotation, index?){
    if(!annotation.dynamic){

      let dialogRef = this.dialog.open(AnnotatedmapAnnotationDialogComponent, {
        data:{
          id:annotation.id,
          type:'static',
          translate: this.translationMode,
          translateOriginal: this.translationModeOriginal,
          values: annotation,
          index: index,
          mapData:this.annotatedMapEditForm.value,
          // translations: this.translationForm?.value?.translations ?? {},
          fields: this.translateFields,
          // columns: columns,
          valuesTranslated: this.valuesTranslated,
          encodedContent: this.actualPolygonOptions[index],
          passId : this.passId,
          widgetNumber: this.widgetNumber,
        },
      });
    
      dialogRef.afterClosed().subscribe(result => {
        if(result[0]){

          if(this.data.translateMode){
            if(!this.data.translateData.originalLanguageData){
              const {title, subtitle, linkURL} = result[1]
              const newannotation = deepCopy(annotation)
              newannotation.title = title
              newannotation.subtitle = subtitle
              newannotation.linkURL = linkURL
      
              this.allAnnotationsMap[index]=newannotation//result[1]
              this.markerPositions[index]=newannotation//result[1]
              this.getPolygon(this.markerPositions[index], index)
              this.annotatedMapEditForm.patchValue({ annotations:this.allAnnotationsMap})
              // this.supportLinkUrl(this.allAnnotationsMap[index].linkURL, this.allAnnotationsMap[index].id)
              this.linkURL[this.allAnnotationsMap[index].id]
            }
          }else{
            const newannotation = deepCopy(result[1])
            this.allAnnotationsMap[index]=newannotation
            this.markerPositions[index]=newannotation
            this.getPolygon(this.markerPositions[index], index)
            this.annotatedMapEditForm.patchValue({ annotations:this.allAnnotationsMap})
            this.linkURL[this.allAnnotationsMap[index].id]
          }
        }
      })
    }else{
      this.openDynamicAnnotationDialog(annotation, index)
    }
  }

  openDynamicAnnotationDialog(annotation, index?){
    let alltranslationsWidget = {}
    let columns = []

    let dialogRef = this.dialog.open(AnnotatedmapAnnotationDynamicDialogComponent, {
      data:{
        id:annotation.id,
        type:'dynamic',
        translate: this.translationMode,
        translateOriginal: this.translationModeOriginal,
        values: annotation,
        index: index,
        mapData:this.annotatedMapEditForm.value,
        // translations: this.translationForm?.value?.translations ?? {},
        fields: this.translateFields,
        // columns: columns,
        valuesTranslated: this.valuesTranslated,
        encodedContent: this.actualPolygonOptions[index],
        passId : this.passId,
        widgetNumber: this.widgetNumber,
      },
    });
    

    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        if(this.data.translateMode ){
          if(!this.data.translateData.originalLanguageData){
            const {title, subtitle, linkURL} = result[1].properties
            const newannotation = deepCopy(annotation)
            newannotation.properties.title = title
            newannotation.properties.subtitle = subtitle
            newannotation.properties.linkURL = linkURL
    
            this.allAnnotationsMap[index]=newannotation//result[1]
            this.allAnnotationsDynamicMap[index]=newannotation//result[1]
            this.markerPositions[index]=newannotation//result[1]
            this.annotatedMapEditForm.patchValue({ annotations:this.allAnnotationsMap })
          }
        }else{
          const newannotation = result[1]
          this.allAnnotationsMap[index]=newannotation//result[1]
          this.allAnnotationsDynamicMap[index]=newannotation//result[1]
          this.markerPositions[index]=newannotation//result[1]
          this.annotatedMapEditForm.patchValue({ annotations:this.allAnnotationsMap })
        }

      }
    })
  }

  openMapDirection(markerPosition){
    return openMapDirection(markerPosition)
  }

  goToLink(url: string){
    window.open(url, "_blank");
  }

  getPolygon(markerPosition, index){
    let pairs
    if(markerPosition['encodedContent']){
      const encodedContent = markerPosition['encodedContent'].split(",")
        pairs = encodedContent.reduce(function(result, value, index, array) {
        if (index % 2 === 0){
          const splited = array.slice(index, index + 2)
          var lat: number = +splited[0];
          var lng: number = +splited[1];
          const value = { lat: lat, lng: lng }
          result.push(value);
        }
        return result;
      }, []);

      this.pairsPath[index] = pairs
      if(markerPosition.type && markerPosition.type == "line"){
        this.actualPolygonOptions[index] = deepCopy(this.polylineOptions)
        this.actualPolygonOptions[index].path = pairs

        if(markerPosition.strokeColor)
          this.actualPolygonOptions[index].strokeColor = markerPosition.strokeColor
      
        if(markerPosition.lineWidth)
          this.actualPolygonOptions[index].strokeWeight = markerPosition.lineWidth

        if(this.actualPolygonOptions[index] && this.actualPolygonOptions[index].path && this.actualPolygonOptions[index].path[0]){
          this.center=this.actualPolygonOptions[index].path[0]
          this.zoom = 9
        }
      }

      if(markerPosition.type && markerPosition.type == "polygon"){
        this.actualPolygonOptions[index] = deepCopy(this.polygonOptions)
        this.actualPolygonOptions[index].paths = pairs

        if(markerPosition.strokeColor)
          this.actualPolygonOptions[index].strokeColor = markerPosition.strokeColor

        if(markerPosition.fillColor)
          this.actualPolygonOptions[index].fillColor = markerPosition.fillColor

        if(markerPosition.lineWidth)
          this.actualPolygonOptions[index].strokeWeight = markerPosition.lineWidth

        if(this.actualPolygonOptions[index] && this.actualPolygonOptions[index].paths && this.actualPolygonOptions[index].paths[0]){
          this.center=this.actualPolygonOptions[index].paths[0]
          this.zoom = 9
        }
      }      
    }
    return pairs
  }

  returnChangesFilters($event){
    this.annotatedMapEditForm.patchValue({filter: $event.newFilters})
  }

  returnChangesStyle($event){
    this.annotatedMapEditForm.patchValue({widgetStyle: $event.newStyle})
  }
}
